import { Box, Typography } from '@mui/material';

import { DrawerFormSection } from '../../../../common/components';
import PaymentOrderProviderSelector from '../PaymentOrderProviderSelector';

const PaymentOrderBatchSection = ({ controller }) => {
  const {
    activeProvider,
    applications,
    handleToggleProvider,
    includedInvoices,
    providerGroups,
    providerMap,
    providerStatuses,
    setActiveProviderId,
    workProvider,
  } = controller;

  return (
    <DrawerFormSection title="Lote por proveedor" grid={false}>
      <Box sx={{ mb: 1.5 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600 }}>
          Seleccioná el proveedor que querés revisar. Cada proveedor trabaja con sus facturas seleccionadas, y desde acá podés incluirlas o excluirlas del lote.
        </Typography>
      </Box>
      <PaymentOrderProviderSelector
        groups={providerGroups}
        applications={applications}
        includedInvoices={includedInvoices}
        activeProviderId={activeProvider?.providerId}
        providerStatuses={providerStatuses}
        providerMap={providerMap}
        onSelectProvider={setActiveProviderId}
        onToggleProvider={handleToggleProvider}
        onWorkProvider={(providerId) => workProvider(providerId || activeProvider?.providerId)}
      />
    </DrawerFormSection>
  );
};

export default PaymentOrderBatchSection;
